import * as actionsFindingKinds from '../Actions/FindingKinds';

export const findingKindsReducer = (state = {}, action) => {
      switch (action.type) {
          case actionsFindingKinds.GET_FINDING_KINDS_DATA_REQUESTED:
              return { ...state, isLoading: true };
          case actionsFindingKinds.GET_FINDING_KINDS_DATA_DONE:
              return { ...state, isLoading: false, findingKinds: action.payload };
          case actionsFindingKinds.GET_FINDING_KINDS_DATA_FAILED:
              return { ...state, isLoading: false, isError: true, error: action.payload };
          default:
              return state;
      }
 };